import { createFeaturedStats } from 'molecules/Stats/config';
import { videoFields } from 'molecules/Video/config';

import type { Input } from '@builder.io/sdk';

const componentVideoFields = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['blue', 'white'],
    defaultValue: 'white',
    showIf: "options.get('variant') !== 'split'",
  },
  {
    name: 'variant',
    type: 'string',
    enum: ['contained', 'full-width', 'split'],
    defaultValue: 'full-width',
  },
  {
    name: 'heading',
    type: 'string',
    showIf: "options.get('variant') === 'full-width'",
  },
  {
    name: 'body',
    type: 'richText',
    showIf: "options.get('variant') !== 'full-width'",
  },
  ...videoFields,
  ...createFeaturedStats("options.get('variant') === 'contained'"),
] as const satisfies DeepReadonly<Input[]>;

const videoComponentConfig = {
  name: 'Component Video',
  inputs: componentVideoFields,
};

export type VideoComponentProps = GenerateBuilder<typeof componentVideoFields>;

export default videoComponentConfig;
